import { CommonModule } from '@angular/common';
import { Component, Input, booleanAttribute } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyChatModule } from '@vendasta/galaxy/chat';

@Component({
  selector: 'inbox-preview',
  standalone: true,
  imports: [CommonModule, GalaxyChatModule, MatIconModule, MatCardModule, GalaxyAlertModule, TranslateModule],
  templateUrl: './inbox-preview.component.html',
  styleUrls: ['./inbox-preview.component.scss'],
})
export class InboxPreviewComponent {
  fakeText = '&nbsp;'.repeat(60);

  @Input({ transform: booleanAttribute }) showAvailabilityMessage = false;
  @Input() availabilityMessage = '';
}
